import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import CancelIcon from '@mui/icons-material/Cancel';
export function PainSection() {
  const problems = ['Te despertás cansada aunque hayas dormido 8 horas', 'La hinchazón aparece sin importar lo que comas', 'Probaste "dietas limpias" que funcionan 3 días y después volvés a cero', 'Los médicos te dicen que "todo está bien" pero vos sabés que algo no cierra', 'Tenés niebla mental, irritabilidad, piel opaca — y no sabés de dónde viene', 'Cada vez que empezás algo nuevo, la motivación dura una semana', 'Sentís que tu cuerpo está en tu contra y ya no sabés qué creerle'];
  return <SectionWrapper className="bg-secondary" data-id="element-165">
      <div className="text-center mb-12" data-id="element-166">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary mb-6" data-id="element-167">
          ¿Cuántas veces más vas a despertar sintiéndote así?
        </h2>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-4" data-id="element-168">
          Querés estar bien. Querés tener energía. Querés sentirte liviana,
          clara, presente.
        </p>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-8" data-id="element-169">
          Pero nadie te dijo que ibas a pasar años probando dietas que no duran,
          suplementos que no funcionan, y consejos contradictorios que te dejan
          más confundida que antes.
        </p>
        <div className="inline-block bg-white py-3 px-6 rounded-lg shadow-sm border-l-4 border-primary" data-id="element-170">
          <p className="font-bold text-xl text-primary" data-id="element-171">
            No es falta de voluntad. Es falta de un sistema.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-6 md:p-10 mb-12" data-id="element-172">
        <h3 className="text-xl font-bold text-gray-800 mb-6 border-b pb-4" data-id="element-173">
          El problema real
        </h3>
        <ul className="space-y-4" data-id="element-174">
          {problems.map((problem, index) => <li key={index} className="flex items-start" data-id="element-175">
              <CancelIcon className="text-red-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-176" />
              <span className="text-gray-700 font-medium" data-id="element-177">{problem}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-178">
        <p className="font-serif text-2xl md:text-3xl text-primary font-bold italic" data-id="element-179">
          ¿Y si este fuera el último lunes que empezás sintiéndote así?
        </p>
      </div>
    </SectionWrapper>;
}